// extracted by mini-css-extract-plugin
module.exports = {"lightColour":"#FAFCFC","midGreyColour":"#868686","greyColour":"#C5C5C5","container":"Menu_container__1qs3b","overlay":"Menu_overlay__1GqY7"};